import CodeOfEthics from "~/components/ethics";
import Metadata from "~/components/metadata";

const CodeOfEthicsPage = () => (
  <>
    <Metadata
      pageTitle="Advante Code of Ethics"
      title="Code of Ethics"
      description="Code of Ethics"
      canonical="https://advante.co/code-of-ethics"
    />

    <CodeOfEthics />
  </>
);
export default CodeOfEthicsPage;
